import React from 'react';
import { useState, useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate, Link as ReactRouterLink } from 'react-router-dom';
import { Alert, Box, Container, Divider, Typography } from '@mui/material';
import { Button, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PaymentsIcon from '@mui/icons-material/Payments';
import { route } from "/@/app/routes.jsx";
import { PlanCard } from "/@/app/views/Subscriptions/PlanCard.jsx";
import { useApi} from '/@/app/Api';
import { Spinner } from "/@/app/components/Spinner.jsx";
import { userState } from "/@/app/states/userState";
import { AppContext } from '/@/app/AppContext';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';

export const SubscriptionsView = () => {
    const api=useApi();
    const { t } = useTranslation();
    const { bootstrapData } = useContext(AppContext);
    const [plans, setPlans] = useState(null);

    useEffect(() => {
        if (plans !== null) return;
        api.request('billing/plans/').then(data => {
            setPlans(data);
        })
    }, []);

    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    };
    const historyPath = route('/subscriptions/history/');

    const telegramPhone = "Nestarenie";
    const messageText = encodeURIComponent("Здравствуйте! Хочу подключить тариф Премиум на Nestarenie.Expert. E-mail моего аккаунта: " + userState.email);
    const messageSubject = encodeURIComponent("Хочу подключить Премиум на Nestarenie.Expert");

    return (
        <Container maxWidth="lg" sx={{ mb: 10 }}>
            <Typography variant="h2" sx={{ textAlign: 'center' }} gutterBottom>Подписки:</Typography>

            {!plans
                ? <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Spinner size={80} />
                </Box>
                : <Box sx={{
                    display: 'flex',
                    flexFlow: 'row wrap',
                    alignItems: 'stretch',
                    justifyContent: 'center',
                    gap: 3,
                }}>
                    {plans.map(plan =>
                        <PlanCard key={ plan.name } plan={ plan } />
                    )}
                </Box>
            }

            <Container
                maxWidth="sm"
                sx={{
                    mt: 3,
                    textAlign: "center",
                }}
                onClick={goBack}
            >
                <Alert severity="info">
                    В случае проблем с оплатой отправьте запрос в Telegram {" "}
                    <a target="_blank" href={`https://t.me/${telegramPhone}?text=${messageText}`}>@{telegramPhone}</a>, {" "}
                    либо напишите на почту {" "}
                    <a href={`mailto:dmitriy-tae@yandex.ru?subject=${messageSubject}&body=${messageText}`}>Dmitriy-tae@yandex.ru</a> {" "}
                    с указанием e-mail регистрации в Nestarenie.Expert
                </Alert>
            </Container>

            <Box
                sx={{
                    mt: 2,
                    display: 'flex',
                    justifyContent: 'center',
                }}
                onClick={goBack}
            >
                <Button><ArrowBackIcon sx={{ mr:1 }} />Вернуться</Button>
            </Box>

            <Box
                sx={{
                    mt: 3,
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <Button component={ReactRouterLink} to={historyPath}>
                    <PaymentsIcon sx={{ mr:1 }} />История подписок
                </Button>
            </Box>

	    { bootstrapData.subscriptions?.promocodes?.length>0
	        && (
<Box sx={{textAlign:'center', marginTop:2}}>
<Typography variant="h4">{t('Ваши промокоды')}</Typography>
<TableContainer sx={{ width: 'fit-content', maxWidth: '100%', mx:'auto' }}>
<Table>
<TableHead>
    <TableRow>
	<TableCell>{t('Код')}</TableCell>
	<TableCell>{t('Промо кампания')}</TableCell>
	<TableCell>{t('Истекает')}</TableCell>
    </TableRow>
</TableHead>
    <TableBody>
			{
	bootstrapData.subscriptions.promocodes.map((promocode) => (
	    <TableRow key={promocode.id}>
		<TableCell sx={{fontSize:'1.5em'}}>{promocode['code']}</TableCell>
		<TableCell>{promocode['name']}</TableCell>
		<TableCell>{promocode['expire'] || t('никогда')}</TableCell>
	    </TableRow>
	))
			}
    </TableBody>
</Table>
</TableContainer>
</Box>
	        )
	    }

            <Container maxWidth="sm" sx={{ textAlign: "center" }}>
                <Divider sx={{ mt: 4 }} />
                <Typography variant="body1" sx={{ fontSize: '14px', mt: 1, mb: 2, lineHeight: '1.3em' }}>
                    * Стоимость подписки может меняться с учетом курса российского рубля к иностранной валюте плательщика на день оплаты.
                </Typography>


                <Link variant="text" component={RouterLink} to={route('/company-details/')}
                      sx={{
                          fontSize: "14px",
                          textDecoration: "none",
                      }}>
                    ОсОО "Нестарение Инвестмент"
                </Link>
            </Container>
        </Container>
    )
}
